<template>
  <Modal @close="$emit('close')" :classes="'col-md-12'" title="Comentarios">
    <div slot="body">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div
              class="row my-2"
              v-for="(comment, i) in comments"
              :key="comment.id"
            >
              <div class="col elevation-2 radius-10">
                <div class="col-12 text-gray">
                  {{ comment.bookUser.firstname }}
                  {{ comment.bookUser.lastname }}
                  en fecha {{ comment.dateComment }}
                  <span>
                    <i
                      class="fa fa-trash pointer icon pt-2"
                      title="Eliminar comentario"
                      @click="openModal(comment.id, i)"
                    />
                  </span>
                </div>
                <hr class="my-1" />
                <div class="col-12 ">{{ comment.content }}</div>
              </div>
            </div>
            <div class="row my-2" v-if="!comments.length">
              <div class="col text-center text-gray">
                <span>
                  No hay comentarios por listar
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col">
                <CustomInput :icon="'fa fa-comment'">
                  <textarea
                    v-model="comment"
                    type="text"
                    slot="input"
                    placeholder="Comentario"
                  >
                  </textarea>
                </CustomInput>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <button class="button logo" @click="addComment">
                  Agregar un nuevo comentario
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        v-if="showModal.deleteModal"
        @close="closeModal"
        @delete="deleteComment"
      />
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal";
import CustomInput from "@/components/CustomInput";
import DeleteModal from "@/components/Books/DeleteModal";

export default {
  name: "CommentsModal",
  components: {
    Modal,
    CustomInput,
    DeleteModal,
  },
  props: ["bookData"],
  data() {
    return {
      data: null,
      comment: null,
      comments: [],
      showModal: {
        deleteModal: false,
      },
      selectedComment: null,
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    openModal(id, position) {
      this.selectedComment = {
        id,
        position,
      };
      this.showModal.deleteModal = true;
    },
    closeModal() {
      this.showModal.deleteModal = false;
      this.selectedComment = null;
    },
    async deleteComment() {
      this.showModal.deleteModal = false;
      let { id, position } = this.selectedComment;

      let apiUrl = `${this.dataUrl}/bookComment/deleteCommentToBook?commentId=${id}`;
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.delete(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.comments.splice(position, 1);

          this.$notify({
            title: ["Comentario eliminado exitosamente"],
            type: "success",
          });
          this.$emit("deletedComment");
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
        this.selectedComment = null;
      }
    },
    async getComments() {
      let apiUrl = `${this.dataUrl}/bookComment/getAllCommentsByBookId?bookId=${this.data.id}`;
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.get(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.comments = data.content;
        } else {
          this.$emit("close");
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$emit("close");
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    async addComment() {
      if (!this.comment) {
        this.$notify({
          title: ["Debe agregar un comentario"],
          type: "danger",
        });

        return;
      }

      let apiUrl = `${this.dataUrl}/bookComment/addCommentToBook`;
      let loader = this.$loading.show();
      let apiData = {
        book: {
          id: this.data.id,
        },
        bookUser: {
          id: this.teacherData.id,
        },
        content: this.comment,
      };

      try {
        let { data } = await this.axios.post(apiUrl, apiData);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.comments.unshift(data.content);
          this.comment = null;
          this.$notify({
            title: ["Comentario agregado exitosamente"],
            type: "success",
          });
          this.$emit("addedComment");
        } else {
          this.$emit("close");
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$emit("close");
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
  mounted() {
    this.data = this.bookData;
    this.getComments();
  },
};
</script>

<style lang="scss" scoped>
.icon {
  float: right;
  color: var(--color-logo);
}
</style>
